"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Source = function Source(_ref) {
  var _theme$breakpoints;

  var breakpoint = _ref.breakpoint,
      file = _ref.file,
      filetyp = _ref.filetyp,
      height = _ref.height,
      width = _ref.width;
  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement("source", {
    media: "(min-width: " + (theme === null || theme === void 0 ? void 0 : (_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.values[breakpoint]) + "px)",
    srcSet: file,
    type: filetyp ? "image/" + filetyp.toLowerCase() : null,
    height: height,
    width: width
  });
};

Source.propTypes = {
  breakpoint: _propTypes.default.string,
  file: _propTypes.default.string.isRequired,
  filetyp: _propTypes.default.string.isRequired,
  height: _propTypes.default.number,
  width: _propTypes.default.number
};
var _default = Source;
exports.default = _default;